import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "gray", "id", "inverse", "testID", "UNSAFE_svgProps", "UNSAFE_pathStyle"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import Shape from '@bubble-ui/primitive-shape';
import Surface from '@bubble-ui/primitive-surface';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { useDesignContext } from '@klarna/designtokens';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var KlarnaLogoSingleLetter = _ref => {
  var {
      accessibilityLabel,
      gray,
      id,
      inverse,
      testID,
      UNSAFE_svgProps,
      UNSAFE_pathStyle
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'KlarnaLogoSingleLetter',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  var designContext = useDesignContext(defaultColorVariables);
  var designVersion = useDesignVersion();

  // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
  // Keep passing all props to the style sheet, even if we don't use them ourselves
  var {
    rootStyle
  } = useStyleSheet(KlarnaLogoSingleLetter, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    accessibilityLabel,
    designContext,
    designVersion,
    gray,
    id,
    inverse,
    testID,
    UNSAFE_svgProps,
    UNSAFE_pathStyle
  }));
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    width: 23,
    height: 20
  }, props), /*#__PURE__*/React.createElement(Shape, _extends({
    d: "M15.8748198,0 L11.4341822,0 C11.4341822,3.63952897 9.76079554,6.98003496 6.84326711,9.16553506 L5.08394788,10.4830746 L11.9006135,19.7782745 L17.5053099,19.7782745 L11.2330694,11.2254093 C14.2061685,8.26470568 15.8748198,4.28172506 15.8748198,0"
  }, _objectSpread(_objectSpread({}, rootStyle), UNSAFE_pathStyle))), /*#__PURE__*/React.createElement(Shape, _extends({
    d: "M0 19.7782745 4.54147255 19.7782745 4.54147255 0 0 0"
  }, _objectSpread(_objectSpread({}, rootStyle), UNSAFE_pathStyle))), /*#__PURE__*/React.createElement(Shape, _extends({
    d: "M20.5152201,15.0295611 C19.142667,15.0295611 18.0300007,16.1422274 18.0300007,17.5147805 C18.0300007,18.8873337 19.142667,20 20.5152201,20 C21.8877733,20 23.0004396,18.8873337 23.0004396,17.5147805 C23.0004396,16.1422274 21.8877733,15.0295611 20.5152201,15.0295611 Z"
  }, _objectSpread(_objectSpread({}, rootStyle), UNSAFE_pathStyle))));
};
KlarnaLogoSingleLetter.displayName = 'KlarnaLogoSingleLetter';
export default withProvisionalOverrideFromContext(KlarnaLogoSingleLetter);
//# sourceMappingURL=index.js.map